import { useMemo } from 'react';

import { EntryFilter } from 'api/data/filters';
import { ApiEntryFilters } from 'api/data/filters/types';
import { getActiveDatasetApiFilters } from 'helpers/analysis';
import { useSelector } from 'hooks/utils';

export function useActiveDatasetFilters(projectId: string): ApiEntryFilters {
	const filtersById = useSelector(state => state.data.filters.dataset.byId);
	const filtersByProjectId = useSelector(state => state.data.filters.dataset.byProjectId);
	const variablesByProjectId = useSelector(state => state.data.variables.byProjectId);

	return useMemo(() => {
		const variablesStoreData = variablesByProjectId[projectId]?.current;
		if (!variablesStoreData) {
			return [];
		}

		const activeFilters: EntryFilter[] =
			filtersByProjectId[projectId]?.active?.map(id => filtersById[id]) ?? [];

		return getActiveDatasetApiFilters(variablesStoreData, activeFilters);
	}, [projectId, filtersById, filtersByProjectId, variablesByProjectId]);
}
